wbApp.filter('aggregateNotes', ['$translate', function ($translate) {
    return function (input) {
        if (input) {
            return input.f(
                $translate.instant('TXT_MONDAY_SHORT'),
                $translate.instant('TXT_TUESDAY_SHORT'),
                $translate.instant('TXT_WEDNESDAY_SHORT'),
                $translate.instant('TXT_THURSDAY_SHORT'),
                $translate.instant('TXT_FRIDAY_SHORT'),
                $translate.instant('TXT_SATURDAY_SHORT'),
                $translate.instant('TXT_SUNDAY_SHORT'));
        }
        return '';
    };
}]);